// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"a8ab70e07fd97cb4bd4a","454":"b8ef4f249d80722ea087"}[chunkId] + ".js";
};